<div class="content-list__top">
  <nz-input-group nzPrefixIcon="search">
    <input
      [(ngModel)]="searchValue"
      name="bundles"
      id="bundles"
      (input)="onSearchInput($event)"
      type="text"
      nz-input
      placeholder="Search..."
    />
  </nz-input-group>
</div>
<div
  class="checkboxes-content"
  [style.height]="listHeight"
  [style.max-height]="listMaxHeight"
>
  <div class="checkboxes-list__every">
    <label
      nz-checkbox
      [(ngModel)]="allChecked"
      [nzDisabled]="isAllDisabled"
      (ngModelChange)="updateAllChecked()"
    >
      All Companies
    </label>
  </div>
  <div
    class="checkboxes-list"
    *ngFor="let company of companies | searchCompanySource : searchValue"
  >
    <div class="checkboxes-list__all">
      <div class="item">
        <label
          [nzDisabled]="company.disabled"
          class="item-name"
          nz-checkbox
          [(ngModel)]="company.checked"
          (ngModelChange)="updateAllEndpointByCompanyChecked($event)"
          [nzIndeterminate]="company.indeterminate"
        >
          {{ company.name }}
        </label>
      </div>
    </div>
  </div>
</div>
